import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';

import { ArrowLink } from './Links';
import * as styles from './NotificationBar.module.scss';

const COOKIE_NAME = '_fs_notification_bar_close';
/* eslint-disable */
const NotificationBar = ({ meta, settings }) => {
  let showNotificationBar;

  const [closed, setClosed] = useState(true);

  let label = settings.notificationBarLabel ? settings.notificationBarLabel : '';
  let link = settings.notificationBarUrl ? settings.notificationBarUrl : '';

  if (meta.displayNotificationBar) {
    showNotificationBar = true;
    label = meta.notificationBarOverrideLabel ? meta.notificationBarOverrideLabel : '';
    link = meta.notificationBarOverrideUrl ? meta.notificationBarOverrideUrl : '';
  } else if (settings.notificationBarDisplayAllPages) {
    showNotificationBar = true;
  } else {
    showNotificationBar = false;
  }

  if ((label === '' && link === '') || settings.overrideIndividualPageNotifications) {
    label = settings.notificationBarLabel;
    link = settings.notificationBarUrl;
  }

  const closeNotificationBar = () => {
    setClosed(true);
    Cookies.set(COOKIE_NAME, true);
    showNotificationBar = false;
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (Cookies.get(COOKIE_NAME)) {
      closeNotificationBar();
    } else {
      setClosed(false);
      Cookies.remove(COOKIE_NAME);
    }
  }, [closed]);

  const display = !closed && showNotificationBar;

  return (
    <div
      className={[styles.notifyBar, display ? styles.show : styles.hide].join(' ')}
      style={{
        display: showNotificationBar ? 'flex' : 'none',
      }}
      data-analytics-section={'notification-bar'}
    >
      <div className={styles.notifyBarText} onClick={closeNotificationBar}>
        <div className={styles.arrowLink}>
          <ArrowLink
            hoverAnimation={true}
            inlineArrow={true}
            label={label}
            url={link}
            isArrowRight
            isExternal
            role="button"
          />
        </div>
        <div className={styles.crossIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
            <path
              d="M1.38513 1.47278L14 14.8861"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 1.47278L1.38513 14.8861"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export { NotificationBar };
